import { useEffect } from 'react';
import { EmeraldError } from 'src/common/api/emerald-error';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import XLRLogger from 'src/common/helpers/logger';
import { store } from 'src/common/redux/configure-store';
import {
  enablePayments,
  inEnablePayment,
  setPinPadTrainingMode,
} from 'src/devices/payment/pinpad-operations';
import { getInterventions } from 'src/interventions/business-logic/get-interventions';
import { getUserActions } from 'src/login/business-logic/service/get-user-actions';
import { popupAsyncMessage } from 'src/messages/business-logic/popup-message';
import { popupNotifications } from 'src/notifications/business-logic/notification-actions-handler';
import { initiateTendering } from 'src/tendering/business-logic/initiate-tendering';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';

export const useInitialHomeState = isEmerald => {
  useEffect((): void => {
    if (store.getState().tendering.isTendering) {
      initiateTendering();
    }

    (async () => {
      if (store.getState().pinPad.isPinpadConfigured) {
        if (!inEnablePayment()) {
          await enablePayments();
        }
        const isTrainingMode = store.getState().posMode.trainingMode;
        await setPinPadTrainingMode(isTrainingMode).catch(() => {
          if (isTrainingMode) {
            return popupAsyncMessage(new EmeraldError('FailedSetPinpadToTrainingMode'));
          }
        });
      }
    })();

    popupNotifications(true);
    if (!isEmerald) {
      getUserActions();
    }

    if (
      store.getState().transaction.transactionIdExists &&
      getCurrentXLRConfig().recallInterventionsSupported
    ) {
      getInterventions().catch(err => {
        const message =
          err instanceof AbortedError
            ? 'Window closed without resolving interventions'
            : err.message;
        XLRLogger.debug({
          message: `Get Interventions: ${message}`,
          source: 'home-page-layout.tsx',
        });
      });
    }
  }, [isEmerald]);
};
